import styled from '@emotion/styled'

type PropsType = {
	page: number
	currPage: number
	selectPage: (i: number) => void
}
const PageBtn = ({ page, currPage, selectPage }: PropsType) => {
	return currPage === page ? (
		<CurrentPageItem>{page}</CurrentPageItem>
	) : (
		<PageItem
			onClick={() => {
				if (selectPage) selectPage(page)
			}}
		>
			{page}
		</PageItem>
	)
}

export const PageItem = styled.button`
	font-family: Open Sans;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	display: inline-block;
	cursor: pointer;
	display: inline-block;
	height: fit-content;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background: none;
	border: none;
`
export const CurrentPageItem = styled(PageItem)`
	color: #003cff;
	font-weight: 600;
`

export default PageBtn
